// ⚙️ OPS — Global operational state drop-killer
// Single source of truth para flags cross-componente (busy, first load, etc.).

export const OPS = {
  busy:  0,
  first: 1,
  page:  document.documentElement.dataset.page || 'login',
}

export const setBusy  = (v) => { OPS.busy = v ? 1 : 0; document.documentElement.classList.toggle('dk-busy', !!v) }
export const noFirst  = ()  => { OPS.first = 0 }
export const setPage  = (p) => {
  OPS.page = p
  document.documentElement.dataset.page = p
}

// Util tiny
export const uid = () => Math.random().toString(36).slice(2, 10)

export const wait = (ms) => new Promise((r) => setTimeout(r, ms))

export const formatBytes = (bytes, decimals = 1) => {
  if (!bytes || bytes < 1) return '0 B'
  const k = 1024
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${units[i]}`
}

export const formatDate = (iso) => {
  if (!iso) return '—'
  const d = new Date(iso)
  const now = new Date()
  const diff = (now - d) / 1000
  if (diff < 60)      return 'ahora mismo'
  if (diff < 3600)    return `hace ${Math.floor(diff / 60)} min`
  if (diff < 86400)   return `hace ${Math.floor(diff / 3600)} h`
  if (diff < 604800)  return `hace ${Math.floor(diff / 86400)} d`
  return d.toLocaleDateString('es-ES', { year: 'numeric', month: 'short', day: 'numeric' })
}

export default OPS
